export const NO_THUMBNAIL_URL = './assets/images/no-image.png'
export const SHOP_NAME_PATTERN = /^(?=.{2,50}$)([\u1780-\u17FFa-zA-Z0-9]+ )*[\u1780-\u17FFa-zA-Z0-9]+$/
export const OWNER_NAME_PATTERN = /^(?=.{2,20}$)([\u1780-\u17FFa-zA-Z0-9]+[_\- ])*[\u1780-\u17FFa-zA-Z0-9]+$/
export const PASSWORD_PATTERN = /(?=^.{6,}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Za-z]).*$/
export const EMAIL_PATTERN = /^\S+@\S+\.\S+$/
export const LINK_PATTERN = /^(http(s)?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/